import { datadogLogs } from '~/lib/datadog';
import { APP_CONSTANTS } from '~/common/explicit-exports';
import StringUtils from '~/common/string-utils';

export const COMMUNITY_LEARNER_PATHS = {
  forum: () => `/community`,
  forumTopic: (topicId = ':topicId', topicName = ':topicName') =>
    `${COMMUNITY_LEARNER_PATHS.forum()}/topics/${topicName}/${topicId}`,
  forumPost: (postId = ':postId', postTitle = ':postTitle') =>
    `${COMMUNITY_LEARNER_PATHS.forum()}/posts/${postTitle}/${postId}`,
  comment: (postId = ':postId', postTitle = ':postTitle', commentId = ':commentId') =>
    `${COMMUNITY_LEARNER_PATHS.forumPost(postId, postTitle)}?comment=${commentId}`,
  commentChild: (postId = ':postId', postTitle = ':postTitle', commentId = ':commentId', childId = ':childId') =>
    `${COMMUNITY_LEARNER_PATHS.comment(postId, postTitle, commentId)}&child=${childId}`,
  profile: () => `${COMMUNITY_LEARNER_PATHS.forum()}/profile`,
  logout: () => `${COMMUNITY_LEARNER_PATHS.forum()}/logout`,
  login: () => `${COMMUNITY_LEARNER_PATHS.forum()}/login`,
};

interface CommunitiesViewUrlTypes {
  type: string;
  topicId?: string;
  topicName?: string;
  postId?: string;
  postTitle?: string;
  commentId?: string;
  childCommentId?: string;
}

export const getCommunitiesViewUrl = ({
  type,
  topicId,
  topicName,
  postId,
  postTitle,
  commentId,
  childCommentId,
}: CommunitiesViewUrlTypes) => {
  if (type === APP_CONSTANTS.NON_ASSET_PICKER_TYPES.COMMUNITY_FORUM_TOPIC) {
    return COMMUNITY_LEARNER_PATHS.forumTopic(topicId, StringUtils.slugify(topicName));
  }

  if (type === APP_CONSTANTS.NON_ASSET_PICKER_TYPES.COMMUNITY_FORUM_POST) {
    return COMMUNITY_LEARNER_PATHS.forumPost(postId, StringUtils.slugify(postTitle));
  }

  if (type === APP_CONSTANTS.NON_ASSET_PICKER_TYPES.COMMUNITY_FORUM_COMMENT) {
    if (childCommentId) {
      return COMMUNITY_LEARNER_PATHS.commentChild(postId, StringUtils.slugify(postTitle), commentId, childCommentId);
    }
    return COMMUNITY_LEARNER_PATHS.comment(postId, StringUtils.slugify(postTitle), commentId);
  }

  datadogLogs.logger.info(`Cannot get community url for ${type}`);
  return COMMUNITY_LEARNER_PATHS.forum();
};
